'use client';

import {
  mapSpotCamToPtzState,
  ptzCameraPayloadAtom,
} from 'store/my-robot/payload/ptzCameraPayload.atom';

import { useDeviceName } from 'lib/api/myRobot';

import { KeyPathParser, useTwinFetcherQuery, useTwinQuerySub } from '../signalR';

export function useReportedPayloadBlkArc() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.PayloadsBlkArc;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { data };
}

// todo with queryClient.setQueryData() we can locally change state
export function useReportedPayloadSpotCam() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.PayloadsSpotCam;
  return useTwinQuerySub(keyPath(deviceName), parser);
}

export function useReportedDataUpload() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.DataUpload;

  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { data };
}

export function useReportedStreaming() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Streaming;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { data };
}

export function useMappedPtzState(deviceName: string) {
  const { keyPath, parser } = KeyPathParser.PayloadsSpotCam;
  const { data: PayloadsSpotCam } = useTwinFetcherQuery(keyPath(deviceName), parser);

  const data = mapSpotCamToPtzState(PayloadsSpotCam);

  return data;
}

export function usePtzCameraPayloadAtom() {
  const { deviceName } = useDeviceName();
  const data = useMappedPtzState(deviceName);

  return ptzCameraPayloadAtom({ deviceName, data });
}
